module.exports = __webpack_public_path__ + "img/long-dark-colored.35f34fd.svg";